module.exports = __webpack_public_path__ + "img/Relay zero-crossing on-off control and setting software.b2dd5539.png";